import React, { FC } from 'react'
import { Flex, Text } from '@ads/front-ds'
import styled, { css } from 'styled-components'
import { lng } from '@ads/front-core/locales'
import { PreviewMethod } from '../interfaces'
import { ICreationPreviewMethod } from './interfaces'

export const NativeSg: FC<ICreationPreviewMethod<PreviewMethod.NATIVE_SG>> = ({
  creation,
}) => (
  <Container gap="s" flexDirection="column" justifyContent="center">
    <Text color="grey50">{lng('campaign:nativeLink.previewDescription')}</Text>
    <a href={creation.content.targetUrl} target="_blank">
      <img src={creation.content.src} alt={creation.content.text} />
      <Title>{creation.content.text}</Title>
    </a>
  </Container>
)

const Container = styled(Flex)`
  position: relative;
`

const Title = styled(Text)`
  ${p => css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 350px;
    padding: 0 10px 10px;
    color: ${p.theme.colors.inverted100};
    font-size: 20px;
    line-height: 24px;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  `}
`
